import LoginSelfSignedDeepLinkBouncePage from "./LoginSelfSignedDeepLinkBouncePageContainer";

export default LoginSelfSignedDeepLinkBouncePage;
